import React, { useRef, useState } from "react";
import { cognitoUserToken } from "../../helpers/userHelper";
import {
  ROW_COUNT,
} from "../../helpers/variableHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import { CellContext, createColumnHelper } from "@tanstack/react-table";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import { IUsuarioExterno } from "../../entities/IUsuarioExterno";
import { UsuariosExternosServices } from "../../services/UsuariosExternosServices";
import AgregarUsuarioExterno from "./AgregarUsuario";
import { Row } from "react-bootstrap";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";

interface IExternalUserAdminProps {
  items?: Array<IUsuarioExterno>;
}


const ExternalUserAdmin = ({ items = [] }: IExternalUserAdminProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<IUsuarioExterno>>(items || []);
  const [showModalAddUser, setShowModalAddUser] = useState(false);
  const [userEdit, setUserEdit] = useState<IUsuarioExterno | null>(null);
  const totalPagesTable = useRef<number>(0);

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);

    filter();
  }, []);


  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentAcciones = (info: any) => {
    return <div>
      <i
        data-testid="test1"
        className="bi bi-search iconSearch colorAzul pointer"
        title="Ver Desviación"
        onClick={() => {
          setUserEdit(info.row.original);
          setShowModalAddUser(true);
        }}
      ></i>
    </div>;
  };

  const componentActivo = (info: any) => {
    return <i>
      <span
        className={`text-dark ${info.getValue() ? "bg-activo" : "bg-noActivo"
          }`}
      >
        {info.getValue() ? "Si" : "No"}
      </span>
    </i>;
  };


  const filter = async (
    filter?: IPagination
  ) => {
    const pagination: IPagination = filter || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    let result = await UsuariosExternosServices.getListUsuariosExternos(
      token,
      pagination
    );
    setListItems(result.data !== undefined ? result.data : items);
    totalPagesTable.current = result.pages;
  };

  const columnHelperTblUsuarios = createColumnHelper<IUsuarioExterno>();
  let columnsDefTblUsuarios = [
    columnHelperTblUsuarios.accessor((row) => row.DISPLAY_NAME, {
      id: "DISPLAY_NAME",
      cell: (info: CellContext<IUsuarioExterno, string>) => (
        componentValue(info.getValue())
      ),
      header: () => component("Nombre Usuario"),
      tipo: ITipo_Campo.text,
    } as any),

    columnHelperTblUsuarios.accessor((row) => row.EMAIL, {
      id: "EMAIL",
      cell: (info: CellContext<IUsuarioExterno, string>) => (
        componentValue(info.getValue())
      ),
      header: () => component("Email"),
      tipo: ITipo_Campo.text,
    } as any),

    columnHelperTblUsuarios.accessor((row) => row.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IUsuarioExterno, boolean>) => (
        componentActivo(info)
      ),
      header: () => component("Activo"),
      tipo: ITipo_Campo.check,
    } as any),
    columnHelperTblUsuarios.accessor((row) => row.ID, {
      id: "ACCIONES",
      cell: (info: CellContext<IUsuarioExterno, string>) => (
        componentAcciones(info)
      ),
      header: () => component("Acciones"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
  ] as any;

  return (
    <div className="rounded bg-white p-2 shadow">
      <div className="container-fluid mb-4">
        <Row>
          <h1 className="titPrincipal colorTit">Usuarios Externos</h1>
          <div className="col-6 pt-2 mb-2">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              data-bs-toggle="offcanvas"
              data-bs-target="#offPanelCrearUsuario"
              aria-controls="offPanelCrearUsuario"
              onClick={() => {
                setShowModalAddUser(true);
              }}
            >
              {" "}
              <i className="bi bi-plus-circle me-2"></i>Agregar Usuario
            </button>
          </div>
        </Row>

        <AdminListaPagination
          defaultSortBy="ID"
          sortDirection="ASC"
          totalPages={totalPagesTable}
          resultPerPage={ROW_COUNT}
          callback={filter}
          data={listItems}
          reload={() => { filter(); }}
          columnsDef={columnsDefTblUsuarios}
          hideAdd={true}
          hideExport={true}
        />
        {showModalAddUser && (
          <AgregarUsuarioExterno
            show={showModalAddUser}
            userEdit={userEdit}
            onClose={() => {
              setUserEdit(null);
              setShowModalAddUser(false);
              filter();

            }}
          />
        )}
      </div>
    </div>
  );
};

export default ExternalUserAdmin;
